import countries from './data/countries.js';

// Convert an ISO alpha-2 country code (e.g. "US") to alpha-3 (e.g. "USA").
// Returns the input unchanged when it cannot be resolved, matching the
// inline secure-checkout behavior the backend relies on.
export const getAlpha3CountryCode = (alpha2Code) => {
	if (!alpha2Code) return alpha2Code;
	const country = countries.find((c) => c['alpha-2'] === alpha2Code);
	return country ? country['alpha-3'] : alpha2Code;
};

// Convert an ISO alpha-3 country code (e.g. "USA") to alpha-2 (e.g. "US").
// Values that are already alpha-2 (length 2) are returned as-is, and
// unresolved values fall back to the original input.
export const getAlpha2CountryCode = (alpha3Code) => {
	if (!alpha3Code) return alpha3Code;
	if (alpha3Code.length === 2) return alpha3Code;
	const country = countries.find((c) => c['alpha-3'] === alpha3Code);
	return country ? country['alpha-2'] : alpha3Code;
};

export { countries };
